// extracted by mini-css-extract-plugin
module.exports = {"contentStore":"_2zjx3","blockRight":"_2ncd2","grid":"_2YVHp","cardStore":"s2ZTN","container":"_1qvDK","inStore":"cPyi5","position":"_2Wlpw"};